let apidaePrestasSearch = {

    props: {
        title: String,
        type: String,
        params: Object,
        groupesFiltres: Array,
        lang: String,
        pmin: Number,
        pmax: Number,
        njmin: Number,
        njmax: Number,
        searchByGeo: Number,
        searchByGeoRange: Number,
        showDate: Number,
        showTarif: Number,
        showFiltre: Number,
        showFiltreResults: Number,
        showFiltreLib: Number,
        showFiltreGroupes: Number,
        showFiltreDate: Number,
        showFiltreAge: Number,
        showFiltrePrice: Number,
        showFiltreCapalibPrestationTif: Number,
        showFiltreNombreChambres: Number,
        showFiltreNombreJours: Number,
        showFiltreNombreNuits: Number,
        showFiltreDistance: Number,
        showFiltreDuration: Number,
        showFiltreElevation: Number,
        showSearchByGeo: Number,
        suggestions: Array
    },
    computed: {
        currentDate: function() {
            return new Date().toJSON().slice(0, 10);
        }
    },
    components: {
        groupFilters,
        filterLib,
        filtreDate,
        filtrePrice,
        filtreNombreJours,
        searchByGeo
    },
    directives: {
        clickaway
    },
    data() {
        return {
            isDropdownActive: false,
            selection: ''
        }
    },
    methods: {
        save() {
            this.$root.submitfilters(event)
        },
        away() {
            this.isDropdownActive = false;
        }
    },
    template: `
    <div class="sidebar-filter">
        <div v-if="showFiltreResults" class="TopBar__headline"><span class="number">{{ params.nbPrestas }}</span> résultats</div>
        <form class="PrestasForm form" @submit.prevent="save">
            <div class="searchBlockContent">
                <template v-if="showFiltreLib">
                    <filter-lib :suggestions="suggestions" v-model="selection"></filter-lib>
                </template>
                <filtre-date v-if="showFiltreDate" :params="params" />
                <template v-if="showFiltreGroupes && !groupeFiltres.hide" v-for="(groupeFiltres, index) in groupesFiltres">
                    <group-filters class="filter-block" :groupe-filtres="groupeFiltres"></group-filters>
                </template>
                <filtre-price v-if="showFiltrePrice" :pmin="pmin" :pmax="pmax" />
                <filtre-nombre-jours v-if="showFiltreNombreJours" :njmin="njmin" :njmax="njmax" />
                <search-by-geo v-if="showSearchByGeo" :search-by-geo="searchByGeo" :search-by-geo-range="searchByGeoRange" />
            </div>
        </form>
    </div>`
}